import type { FieldEngineerRecommendation } from '@/types/ticket'
import type { FieldEngineerSummary } from '@/store/parentTicket'

/** Canonical id stored on parent tickets (field_engineers.id). */
export function getFeStorageId(fe: FieldEngineerRecommendation): string {
  return String(fe.field_engineer_id)
}

export function engineerIdsMatch(
  storedId: string | number | undefined | null,
  fe: FieldEngineerRecommendation
): boolean {
  if (storedId == null || storedId === '') return false
  const s = String(storedId)
  return s === String(fe.field_engineer_id) || (fe.user_id != null && s === String(fe.user_id))
}

export function engineerSummaryMatches(
  storedId: string | number | undefined | null,
  summary: Pick<FieldEngineerSummary, 'id' | 'user_id'>
): boolean {
  if (storedId == null || storedId === '') return false
  const s = String(storedId)
  return s === String(summary.id) || (summary.user_id != null && s === String(summary.user_id))
}
